import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "已停产",
  "Spare part list": "备件清单",
  "Download Excel": "下载 Excel",
  "Recent search list": "最近搜索列表",
  "No data": "输入的搜索参数无数据",
  "spare part": "零配件",
  "none": "无",
  "no value": "无价值",
  "No results found": "未找到结果",
  "Spare parts for": "备件",
  "Could not load cumulated data": "无法加载累积数据",
  "commissioning part": "调试部分",
  "wear part": "磨损件",
  "Search": "搜索",
  "Tk": "Tk",
  "Spare part number": "备件编号",
  "drawing": "图画",
  "Products for": "产品用于",
  "Available": "可用",
  "MM": "MM",
  "The entered order code is invalid": "输入的订单代码无效",
  "Recommended": "推荐",
  "No data available for the entered search parameters": "输入的搜索参数无数据",
  "Search spare parts": "搜索备件",
  "Order code / product root / serial number": "订购代码/产品根号/序列号",
  "Characteristic": "特征",
  "Please enter an order code": "请输入订单代码",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "在质量和安全方面，Endress+Hauser 强烈建议只使用原装的 Endress+Hauser 备件。\n该仪器只能由合格人员维护和修理。\n必须遵守设备文件的适用标准和法律要求以及任何证书！",
  "Maintenance advice": "维护建议",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "我的备件可用于哪些产品？\\填写备件订购代码（如 71002865 或 XPD0024），可显示该备件可用于的相关设备。",
  "tool": "工具",
  "Production numbers": "生产数量",
  "New alternative": "新的选择",
  "There are no items selected. Please use the checkboxes to make your selection": "警告",
  "Service segmentation": "服务细分",
  "Seg": "分段",
  "Valid": "有效",
  "Pos": "Pos",
  "Value": "价值",
  "service segmentation 2": "需要基本知识的部分。成功参加 E+H 基础培训是前提条件。",
  "Phase out date": "淘汰日期",
  "service segmentation 1": "需要基本知识的部分。",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "我的产品有哪些备件？\\n 填写订单代码（如 FTC260-AA2A1 或 PMC51-BA21JB1CGBTDJB）或产品 ID（如 FTC260 或 83F50）即可显示相关备件。",
  "Set filter": "设置过滤器",
  "Search date": "搜索日期",
  "Group": "组别",
  "Warning": "未选择任何项目。请使用复选框进行选择",
  "Description": "说明",
  "Cancel": "取消",
  "service segmentation 4": "用于工厂维修的部件。必须具备专业知识。",
  "service segmentation 3": "需要专业知识的部件。成功参加 E+H 高级培训是前提条件。",
  "Drawing Position Number": "图纸位置编号",
  "Spare parts search": "查找备件",
  "Confirm": "确认",
  "Ordercode too short": "订购代码太短",
  "Product status": "产品状态",
  "Open": "开放",
  "Clear": "清晰",
  "PDF file with assembly instructions": "包含组装说明的 PDF 文件",
  "Search products": "搜索产品",
  "Export": "出口",
  "Production date": "生产日期",
  "Order stop": "订单停止",
  "Calibration until": "校准直至",
  "PDF file with compatibility information": "包含兼容性信息的 PDF 文件",
  "Add selection to cart": "将选择添加到购物车",
  "Mounting advices": "安装建议",
  "Recommended parts only": "仅推荐部件",
  "not applicable": "开",
  "accessories": "配件",
  "Cumulative spare parts list": "累积备件清单",
  "YYYY": "YYYY",
  "Title": "标题",
  "Error": "错误",
  "Ordercode too long": "订购代码太长",
  "Functions": "功能",
  "Rec": "Rec",
  "Type": "类型",
  "Spare sensor until": "备用传感器，直到",
  "Spare parts until": "备件直至",
  "Filter": "过滤器",
  "Check all": "全部检查",
  "Order code": "订购代码",
  "Repair until": "维修直至",
  "Tag": "标签",
  "Ok": "好的",
  "Category code": "类别代码",
  "Phase out": "淘汰",
  'Compatibility advices': '附加文档',
  'Co.': '附加文档',
} as LocalizedDictionary;
